import React, { useState } from "react";
import { styled } from "@mui/material/styles";

const ChipContainer = styled("div")({
  position: "relative",
  display: "inline-block",
});

const CustomChip = styled("div")(({ active, disabled }) => ({
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "10px",
  backgroundColor: disabled ? "#DEDEDE" : active ? "#FB4764" : "#fff1f2",
  color: disabled ? "#1D1B201A" : active ? "#FFFFFF" : "#FB4764",
  borderRadius: "15px",
  border: disabled ? "none" : "1px solid #FB4764",
  fontSize: "14px",
  minWidth: "54px",
  height: "38px",
  cursor: "pointer",
}));

const PreviewContainer = styled("div")({
  position: "absolute",
  bottom: "calc(100% + 12px)",
  left: "50%",
  transform: "translateX(-50%)",
  backgroundColor: "#FFFFFF",
  borderRadius: "16px",
  padding: "14px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  "&::after": {
    content: '""',
    position: "absolute",
    top: "100%",
    left: "50%",
    transform: "translateX(-50%)",
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderTop: "8px solid #FFFFFF",
  },
});

const PreviewTitle = styled("div")({
  fontSize: "14px",
  fontWeight: 400,
  color: "#FB4764",
  textAlign: "center",
});

const PreviewBox = styled("div")(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
  backgroundColor: "#FB4764",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#FFFFFF",
  fontSize: "18px",
  fontWeight: 500,
}));

const ADSChip = ({
  onClick,
  active,
  label,
  disabled = false,
  withTooltip = false,
  aspectRatioSettings = {},
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (disabled) {
      return;
    }
    setIsHovered(false);
    onClick?.();
  };

  // Get aspect ratio configuration from passed settings
  const { text = label, width = 80, height = 80 } = aspectRatioSettings;

  const showTooltip = withTooltip && isHovered && !disabled;

  return (
    <ChipContainer
      onMouseEnter={() => withTooltip && setIsHovered(true)}
      onMouseLeave={() => withTooltip && setIsHovered(false)}
    >
      {showTooltip && (
        <PreviewContainer>
          <PreviewTitle>{text}</PreviewTitle>
          <PreviewBox width={width} height={height}>
            {label}
          </PreviewBox>
        </PreviewContainer>
      )}
      <CustomChip onClick={handleClick} active={active} disabled={disabled}>
        {label}
      </CustomChip>
    </ChipContainer>
  );
};

export default ADSChip;
